import { createFileRoute } from '@tanstack/react-router'

import { CallsPage } from '#/modules/communication/calls-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/calls/')({
  component: CallsPage,
  validateSearch: validateListSearch,
})
